import { createClient } from '@supabase/supabase-js';

const DEVELOPMENT_PROJECT_REF = 'qwrwwfrlrtjfehsgxmgy';
const isDevelopment = import.meta.env.DEV;
export const supabaseUrl = isDevelopment
  ? (import.meta.env.VITE_DEV_SUPABASE_URL || `https://${DEVELOPMENT_PROJECT_REF}.supabase.co`)
  : import.meta.env.VITE_PUBLIC_SUPABASE_URL;
export const supabaseAnonKey = isDevelopment
  ? (import.meta.env.VITE_DEV_SUPABASE_ANON_KEY || 'development-anon-key-not-configured')
  : import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (isDevelopment) {
  let developmentRef = '';
  try { developmentRef = new URL(supabaseUrl).hostname.match(/^([a-z0-9]{20})\.supabase\.co$/i)?.[1]?.toLowerCase() || ''; }
  catch { /* The project pin check below fails closed. */ }
  if (developmentRef !== DEVELOPMENT_PROJECT_REF) {
    throw new Error('Development Supabase configuration does not match lavyn-development.');
  }
}

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Supabase is not configured. Add VITE_PUBLIC_SUPABASE_URL and VITE_PUBLIC_SUPABASE_ANON_KEY to Replit Secrets.',
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});